<script>
// const API_HOST = 'https://web-test.risafety.com/user/login';//测试地址
const API_HOST = 'https://ams.risensafe.com/';//正式地址
export default
{
  API_HOST// serversUrl
}
// export function Cors(url) {
//   return new Promise((resolve, reject) => {
//     const xhr = new XMLHttpRequest();
//     console.log('000');
//     xhr.open('POST', url, true);
//     xhr.withCredentials = true; // 设置运行跨域操作
//     xhr.send();
//     xhr.onload = () => {}
//       const text = xhr.responseText;
//       if (xhr.status === 200) {
//         resolve(JSON.parse(text));
//       } else {
//         let error = new Error(text);
//         error.response = xhr;
//         reject(error);
//       }
//     };
//   });
// }
</script>



// WEBPACK FOOTER //
// src/request/http.vue